var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"custom-button",attrs:{"x-large":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"px-1"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }